import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import StickersList from "./views/StickersList";
import * as stickersActions from "../../../../redux/modules/stickers";
import * as optionsActions from "../../../../redux/modules/options";

const mapStateToProps = state => {
  return {
    loading: state.stickers.loading,
    success: state.stickers.success,
    message: state.stickers.message,
    data: state.stickers.data,
    total: state.stickers.total,
    limit: state.stickers.limit,
    page: state.stickers.page,
    order: state.stickers.order,
    orderMode: state.stickers.orderMode,
    deleted: state.stickers.deleted,
    deletedId: state.stickers.deletedId,
    token: state.stickers.token,

    headerLoaded: state.options.headerLoaded,
    translate: state.options.translate,
    searchModel: state.options.searchModel,
    columns: state.options.columns,
    columnsOrder: state.options.columnsOrder,
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getListHeader: optionsActions.getGridInfo,
      optionsReset: optionsActions.reset,

      getList: stickersActions.stickersList,
      delete: stickersActions.stickerDelete,
      setLoading: stickersActions.setLoading
      //reset: stickersActions.reset
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StickersList);



// WEBPACK FOOTER //
// ./src/Containers/Pages/Cashregisters/Stickers/StickersList.js